/**
 * Format an array of fulfiller objects into a display name string.
 *
 * 0 names  -> null
 * 1 name   -> "Alice"
 * 2 names  -> "Alice & Bob"
 * 3+ names -> "Alice, Bob + N more"
 */
const formatFulfillerNames = (fulfillers) => {
  const names = (fulfillers || []).map((f) => f.name).filter(Boolean);
  if (names.length === 0) return null;
  if (names.length <= 2) return names.join(" & ");
  return `${names[0]}, ${names[1]} + ${names.length - 2} more`;
};

/**
 * Format co-fulfiller names excluding the current signer.
 *
 * 0 others  -> null
 * 1 other   -> "with Alice"
 * 2 others  -> "with Alice & Bob"
 * 3+ others -> "with Alice + N more"
 */
export const formatOtherFulfillerNames = (fulfillers, currentInfluencerId) => {
  const others = (fulfillers || [])
    .filter((f) => f.influencerId !== currentInfluencerId)
    .map((f) => f.name)
    .filter(Boolean);
  if (others.length === 0) return null;
  if (others.length === 1) return `with ${others[0]}`;
  if (others.length === 2) return `with ${others[0]} & ${others[1]}`;
  return `with ${others[0]} + ${others.length - 1} more`;
};

export default formatFulfillerNames;
